import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { fetchCustomerProductsTechnician, fetchCustomerProductsInstaller, addCustomerProduct } from "./endpoints";
import { TECHNICIAN } from "modules/Authentication/constants";
import { getErrorMessage } from "../helpers";
export const useCustomerProducts = (customerId) => {
    const queryClient = useQueryClient();
    const role = useSelector((state) => state.authentication.role);
    const technician = role === TECHNICIAN;
    /* ---------------- Fetch Customer Products ---------------- */
    const { data: customerProducts = [], isLoading, isFetching, isError, error, } = useQuery({
        queryKey: ['customer-products', customerId],
        queryFn: () => technician
            ? fetchCustomerProductsTechnician(customerId)
            : fetchCustomerProductsInstaller(customerId),
        enabled: !!customerId
    });
    /* ---------------- Add Product ---------------- */
    const addProductMutation = useMutation({
        mutationFn: addCustomerProduct,
        onSuccess: (newProducts, variables) => {
            const { customerId } = variables;
            queryClient.setQueryData(['customer-products', customerId], old => {
                const tagged = newProducts.map((product) => (Object.assign(Object.assign({}, product), { newProduct: true })));
                return [...(old !== null && old !== void 0 ? old : []), ...tagged];
            });
            queryClient.invalidateQueries(['agreements', customerId]);
        }
    });
    return {
        customerProducts,
        isCustomerProductsLoading: isLoading,
        isCustomerProductsFetching: isFetching,
        customerProductsErrorMessage: getErrorMessage(error),
        addProduct: addProductMutation.mutate,
        isAddingProduct: addProductMutation.isLoading,
        addProductErrorMessage: getErrorMessage(addProductMutation.error),
    };
};
